/**
 * Standardized Node Definitions
 * All CC nodes are defined here using the createNode factory and NODE_REGISTRY
 */

import { NodeType } from "components/CC/types/enums";

import { createNode, NodeConfig } from "./createNode";
import { EndNode } from "./EndNode/EndNode";
import { HttpNode } from "./HttpNode/HttpNode";
import { MirrorNode } from "./MirrorNode/MirrorNode";
import { NODE_REGISTRY } from "./node-config";
import { StartNode } from "./StartNode/StartNode";

// =============================================================================
// Node Configurations from Registry
// =============================================================================

const createNodeConfig = (type: NodeType, overrides?: Partial<NodeConfig>): NodeConfig => {
    const entry = NODE_REGISTRY[type];
    const Icon = entry.icon;
    return {
        color: entry.color,
        title: entry.title,
        icon: <Icon />,
        ...overrides,
    };
};

// =============================================================================
// Generated Node Components
// =============================================================================

// Flow control
export const WaitNode = createNode(createNodeConfig(NodeType.Wait));
export const RepeaterNode = createNode(createNodeConfig(NodeType.Repeater));

export const BreakerNode = createNode(createNodeConfig(NodeType.Breaker));

// Data operations
export const ModifyFieldNode = createNode(createNodeConfig(NodeType.Modify));
export const SetNode = createNode(createNodeConfig(NodeType.Set));

// Connections
export const WebhookNode = createNode(createNodeConfig(NodeType.Webhook));
export const SubScenarioNode = createNode(createNodeConfig(NodeType.SubScenario));

// =============================================================================
// Node Types Map (for ReactFlow)
// =============================================================================

export const standardNodeTypes = {
    [NodeType.Wait]: WaitNode,
    [NodeType.Repeater]: RepeaterNode,
    [NodeType.Breaker]: BreakerNode,
    [NodeType.End]: EndNode,
    [NodeType.Start]: StartNode,
    [NodeType.Modify]: ModifyFieldNode,
    [NodeType.Set]: SetNode,
    [NodeType.Mirror]: MirrorNode,
    [NodeType.Webhook]: WebhookNode,
    [NodeType.SubScenario]: SubScenarioNode,
    [NodeType.Http]: HttpNode,
};

// =============================================================================
// Re-exports (special nodes with custom logic, defined in their own files)
// =============================================================================

export { EndNode, HttpNode, MirrorNode, StartNode };
